// Effets sonores synthétisés (Web Audio) — aucun fichier requis.
let ctx = null;
let muted = typeof localStorage !== "undefined" && localStorage.getItem("de_muted") === "1";

function ac() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

function tone(freq, dur, type = "sine", gain = 0.06, delay = 0) {
  if (muted) return;
  const c = ac();
  if (!c) return;
  const t = c.currentTime + delay;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  g.gain.setValueAtTime(gain, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(t);
  o.stop(t + dur);
}

export const sfx = {
  click: () => tone(420, 0.07, "triangle", 0.045),
  choose: () => tone(540, 0.09, "triangle", 0.05),
  success: () => {
    tone(660, 0.1, "sine", 0.06);
    tone(880, 0.14, "sine", 0.06, 0.09);
  },
  fail: () => {
    tone(200, 0.18, "sawtooth", 0.05);
    tone(140, 0.22, "sawtooth", 0.05, 0.1);
  },
  tick: () => tone(920, 0.04, "square", 0.03),
  win: () => [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.18, "triangle", 0.07, i * 0.11)),
  lose: () => [330, 262, 196].forEach((f, i) => tone(f, 0.2, "sawtooth", 0.05, i * 0.14)),
  voteOpen: () => {
    tone(392, 0.1, "triangle", 0.06);
    tone(587, 0.13, "triangle", 0.06, 0.1);
  },
  reveal: () => {
    tone(784, 0.09, "triangle", 0.07);
    tone(1047, 0.16, "sine", 0.07, 0.09);
  },
  victory: () => [523, 659, 784, 1047, 1319].forEach((f, i) => tone(f, 0.2, "triangle", 0.07, i * 0.12)),
};

export function resumeAudio() {
  try {
    const c = ac();
    if (c && c.state === "suspended") c.resume();
  } catch (e) {
    /* ignore */
  }
}

export function toggleMute() {
  muted = !muted;
  if (typeof localStorage !== "undefined") localStorage.setItem("de_muted", muted ? "1" : "0");
  return muted;
}

export function isMuted() {
  return muted;
}
